import i18next from 'i18next';

import { appConfig } from '../config/customization';

export const message = (resource, i18params) =>
  i18params
    ? i18next.t(`${appConfig.i18n}${resource}`, i18params)
    : i18next.t(`${appConfig.i18n}${resource}`);

export const asciiToHex = string => {
  const hexResult = [];
  for (let n = 0, l = string.length; n < l; n += 1) {
    const hex = Number(string.charCodeAt(n)).toString(16);
    hexResult.push(hex);
  }
  return hexResult.join('');
};

export const replaceWithCircle = string => string.replace(/[0-9]/g, '\u25cf');

export const getUrlBase = url => url.substring(0, url.indexOf('?'));
